module.exports = __webpack_public_path__ + "img/game3.9fd00771.png";